<template>
  <div class="container">
    <div class="header">
      <h2 class="title is-2" style="marginBottom: 0;">Upload Proposal Files</h2>
      <button class="button is-primary" style="width: 10rem;" @click="toSubmissionsOverview">
        Skip
      </button>
    </div>

    <div class="body">
      <p>
        Upload files to be attached to the proposals you just created.
      </p>
      <p>
        The files should match the name of the 'Proposal File Name' column in the spreadsheet that
        was just uploaded. Files should be compressed and uploaded as a zip drive.
      </p>

      <div class="file-upload">
        <p class="title is-4" style="marginBottom: 1rem;">Selected File</p>
        <p v-if="selectedFile" class="has-text-weight-bold">{{ selectedFile.name }}</p>
        <p v-if="!selectedFile" class="has-text-weight-bold">No File Selected</p>
        <div class="divider"></div>
        <div class="file-upload__buttons">
          <button
            class="button"
            style="width: 10rem; marginRight: 1.5rem;"
            @click="handleUploadClick"
          >
            <input
              id="file-upload"
              type="file"
              accept=".zip"
              hidden
              ref="file"
              @change="handleUpload"
            />
            <i>Choose File</i>
          </button>
          <button
            class="button is-primary"
            @click="uploadFiles()"
            :disabled="!selectedFile || uploading"
          >
            Upload
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*
  NOTE: The terms Proposal and Application are used interchangeably throughout this application.
*/
import Application from '@/services/applications'

import LoadingBox from '@/components/LoadingBox'

export default {
  name: 'StaffUploadApplicationFiles',
  components: {
    LoadingBox,
  },
  data() {
    return {
      isUploadDisabled: false,
      selectedFile: null,
      uploading: false,
    }
  },
  methods: {
    handleUploadClick() {
      document.getElementById('file-upload').click()
    },
    handleUpload(e) {
      this.selectedFile = e.target.files[0]
    },
    async uploadFiles() {
      try {
        this.uploading = true
        const response = await Application.api.uploadApplicationFiles(this.selectedFile)

        // Reset state
        this.selectedFile = null

        this.$Alert.alert({
          type: 'info',
          message: `<p>${response.applicationsUpdated} Files Uploaded!</p>`,
          timeout: 6000,
        })
        this.$router.push({ name: 'SubmissionsOverview' })
      } catch (err) {
        console.log(err)
        this.$Alert.alert({
          type: 'error',
          message: `<p>Error Uploading files</p>`,
          timeout: 6000,
        })
      } finally {
        this.uploading = false
      }
    },
    toSubmissionsOverview() {
      this.$router.push({ name: 'SubmissionsOverview' })
    },
  },
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 4rem 0 3rem 0;
}

.file-upload {
  margin-top: 2rem;
  &__buttons {
    display: flex;
    align-items: center;
    margin-top: 2rem;
  }
}

.divider {
  height: 1px;
  border: 1px solid lightgray;
  width: 20rem;
}
</style>
